module.exports = __webpack_public_path__ + "static/media/AkuntansiUnila.4e30a00c.WebP";